import {
    tentativePackagesFromTentatives,
    tentativeSectionsFromTentatives,
    tentativeServicesFromTentatives,
} from './tentativeHelpers.js';
import { v4 as uuidv4 } from 'uuid';

export function createRandomKey() {
    return uuidv4();
}

export function addFrontendPropertiesToTentatives(tentatives, tentativeConfig) {
    let modifiedTentatives = tentatives;
    if (tentativeConfig.type === 'lines') {
        tentativePackagesFromTentatives(tentatives).forEach((tentativePackage) => {
            addFrontendPropertiesToSingle(tentativePackage);
        });
    }
    tentativeSectionsFromTentatives(tentatives).forEach((tentativeSection) => {
        addFrontendPropertiesToSingle(tentativeSection);
    });
    let randomKeyMap = {};
    tentativeServicesFromTentatives(tentatives).forEach((tentativeService) => {
        addFrontendPropertiesToSingle(tentativeService);
        randomKeyMap[tentativeService.external_id] = tentativeService.random_key;
    });
    tentativeServicesFromTentatives(tentatives).forEach((tentativeService) => {
        if (tentativeService.parent_external_id) {
            tentativeService.parent_random_key = randomKeyMap[tentativeService.parent_external_id];
        }
    });
    return modifiedTentatives;
}

export function addIndexesAsOrderToTentatives(tentatives, tentativeConfig) {
    let modifiedTentatives = tentatives;
    if (tentativeConfig.type === 'lines') {
        tentativePackagesFromTentatives(tentatives).forEach((tentativePackage, index) => {
            tentativePackage.order = index;
        });
    }
    tentativeSectionsFromTentatives(tentatives).forEach((tentativeSection, index) => {
        tentativeSection.order = index;
    });
    tentativeServicesFromTentatives(tentatives).forEach((tentativeService, index) => {
        tentativeService.order = index;
    });
    return modifiedTentatives;
}

export function addFrontendPropertiesToSingle(object) {
    object.open = true;
    object.changes = [];
    object.errors = [];
    object.random_key = createRandomKey();
    object.parent_random_key = '';
}
